<template>
  <div id="table-wrap" class="table-wrapper">
    <el-table :ref="refName" :show-header="showHeader" :data="tableData" :header-cell-style="tableHeaderColor"
      :style="tableWidth" :height="tableHeight" :size="tableSize" border @select="selectOpt" @select-all="selectAll">
      <!-- 展开详情 -->
      <el-table-column type="expand" fixed="left" v-if="expand">
        <template slot-scope="scope">
          <el-form label-position="left" inline class="demo-table-expand" v-if="scope.row.paragraphs">
            <pre style="text-align: center"
              v-if="scope.row.paragraphs.length > 0">{{ scope.row.paragraphs.join("\n") }}</pre>
            <pre style="text-align: center" v-if="
              scope.row.paragraphs.length === 0 &&
              scope.row.content.length > 0
            ">{{ scope.row.content.join("\n") }}</pre>
            <pre style="text-align: center; color: #999" v-if="
              scope.row.paragraphs.length === 0 &&
              scope.row.content.length === 0
            ">
暂无诗词内容</pre>
          </el-form>
          <el-form label-position="left" inline class="demo-table-expand" v-if="scope.row.translations">
            <pre style="text-align: center">{{
              scope.row.translations.join("\n")
            }}</pre>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column type="selection" align="center" v-if="selectCtrl" :selectable="selectable" width="50">
      </el-table-column>

      <el-table-column type="index" align="center" :label="labelNo" fixed="left" v-if="orderCtrl" :key="Math.random()"
        width="50">
        <template slot-scope="scope">
          <span v-if="!!pageSize">{{
            (currentPage - 1) * pageSize + scope.$index + 1
          }}</span>
          <span v-else>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column v-for="{ prop, label, width, minWidth, btn, obj } in tableProps" align="center"
        show-overflow-tooltip :prop="prop" :key="prop" :label="label" :fixed="prop === 'handle' ||
          prop === 'giftHandle' ||
          prop === 'giftDetailsHandle'
          ? 'right'
          : false || prop === 'cardDetailsHandle'
            ? 'right'
            : false
          " :width="width" :min-width="minWidth">
        <template slot-scope="scope">
          <div v-if="obj" class="omitText">
            <span v-if="prop === 'useinfo.lastTime'">{{
              scope.row | filterObj(prop) | filterDate
            }}</span>
            <span v-else-if="prop === 'useinfo.enable'">{{
              scope.row | filterObj(prop) ? "是" : "否"
            }}</span>
            <span v-else>{{ scope.row | filterObj(prop) }}</span>
          </div>

          <div class="omitText" v-else-if="
            prop === 'updated_at' ||
            prop === 'created_at' ||
            prop === 'createdAt' ||
            prop === 'updatedAt' ||
            prop === 'publishAt' ||
            prop === 'endAt' ||
            prop === 'pay_time' ||
            prop === 'liveAt'
          ">
            <span v-if="scope.row[prop]">{{
              scope.row[prop] | filterDate
            }}</span>
            <span v-else>-</span>
          </div>

          <div class="omitText" v-else-if="prop === 'sysNotice_status'">
            <div v-if="scope.row['endAt'] && scope.row['endAt'] !== null">
              <span v-if="
                new Date().getTime() > new Date(scope.row['endAt']).getTime()
              " class="delBtn">已过期</span>
              <span v-else>未过期</span>
            </div>
            <span v-else>长期有效</span>
          </div>
          <div class="omitText" v-else-if="prop === 'orders_status'">
            <span v-if="scope.row['status'] !== null">{{
              scope.row["status"] | filterOrdersStatus
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'vip_type'">
            <span v-if="scope.row[prop] !== null">{{
              scope.row[prop] | filterVipTypes
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'force'">
            <span>{{ scope.row[prop] | filterUpdateTypes }}</span>
          </div>

          <div class="omitText" v-else-if="prop === 'gift_status'">
            <span v-if="scope.row['status'] !== null">{{
              scope.row["status"] | filterGiftStatus
            }}</span>
            <span v-else>-</span>
          </div>

          <div class="omitText" v-else-if="prop === 'card_total'">
            <span>{{ scope.row[prop] }}</span>
          </div>

          <!-- 派发日期 -->
          <div class="omitText" v-else-if="prop === 'actived'">
            <span v-if="scope.row['actived'] === 0">未领取</span>
            <span v-if="scope.row['actived'] === 1" class="successText">已领取</span>
          </div>

          <!-- 派发日期 -->
          <div class="omitText" v-else-if="prop === 'outAt'">
            <span>{{ scope.row[prop] | filterDate }}</span>
          </div>

          <!-- 诗词库-发布状态 -->
          <div class="omitText" v-else-if="prop === 'publish'">
            <span v-if="scope.row[prop]" class="successText">已发布</span>
            <span v-if="!scope.row[prop]">未发布</span>
          </div>

          <div class="omitText" v-else-if="prop === 'card_ratio'">
            <span v-if="scope.row['CardCount'] > 0 && scope.row['cardGetCount'] > 0">{{
              (
                (scope.row["cardGetCount"] / scope.row["CardCount"]) *
                100
              ).toFixed(2)
            }}%</span>
            <span v-if="
              scope.row['CardCount'] === 0 || scope.row['cardGetCount'] === 0
            ">0</span>
          </div>

          <div class="omitText" v-else-if="prop === 'operation'">
            <span v-if="scope.row[prop] !== null">{{
              scope.row[prop] | filterGiftTypes
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'giftContent'">
            <div v-if="scope.row['operation'] === 'edit'">
              <div v-if="
                scope.row['beforeEditContent'].hasOwnProperty('phone') &&
                scope.row['beforeEditContent'].hasOwnProperty('code')
              ">
                <div>
                  <span>手机修改：</span>
                  <span>{{
                    scope.row["beforeEditContent"].phone
                      ? scope.row["beforeEditContent"].phone
                      : "无"
                  }}</span>
                  <span>{{
                    scope.row["afterEditContent"].phone
                      ? scope.row["afterEditContent"].phone
                      : "无"
                  }}</span>
                </div>
                <div>
                  <span>卡号修改：</span>
                  <span>{{
                    scope.row["beforeEditContent"].code
                      ? scope.row["beforeEditContent"].code
                      : "无"
                  }}</span>
                  <span>{{
                    scope.row["afterEditContent"].code
                      ? scope.row["afterEditContent"].code
                      : "无"
                  }}</span>
                </div>
              </div>
              <div v-else-if="
                scope.row['beforeEditContent'].hasOwnProperty('phone') &&
                !scope.row['beforeEditContent'].hasOwnProperty('code')
              ">
                <span>手机修改：</span>
                <span>{{
                  scope.row["beforeEditContent"].phone
                    ? scope.row["beforeEditContent"].phone
                    : "无"
                }}</span>
                <span>{{
                  scope.row["afterEditContent"].phone
                    ? scope.row["afterEditContent"].phone
                    : "无"
                }}</span>
              </div>
              <div v-else-if="
                scope.row['beforeEditContent'].hasOwnProperty('code') &&
                !scope.row['beforeEditContent'].hasOwnProperty('phone')
              ">
                <span>卡号修改：</span>
                <span>{{
                  scope.row["beforeEditContent"].code
                    ? scope.row["beforeEditContent"].code
                    : "无"
                }}</span>
                =>
                <span>{{
                  scope.row["afterEditContent"].code
                    ? scope.row["afterEditContent"].code
                    : "无"
                }}</span>
              </div>
            </div>
            <div v-else-if="scope.row['operation'] === 'create'">
              <div v-if="scope.row['afterEditContent'].hasOwnProperty('phone')">
                <span>手机：{{
                  scope.row["afterEditContent"].phone
                    ? scope.row["afterEditContent"].phone
                    : "无"
                }}</span>
              </div>
              <div v-if="scope.row['afterEditContent'].hasOwnProperty('code')">
                <span>卡号：{{
                  scope.row["afterEditContent"].code
                    ? scope.row["afterEditContent"].code
                    : "无"
                }}</span>
              </div>
            </div>
            <div v-else-if="scope.row['operation'] === 'del'">
              <span>状态：</span>
              <span>已删除</span>
            </div>
            <div v-else-if="scope.row['operation'] === 'copyCode'">
              <span>激活状态：</span>
              <span>已激活</span>
            </div>
            <div v-else-if="scope.row['operation'] === 'active gift'">
              <span>激活状态：</span>
              <span>已激活</span>
            </div>
            <div v-else-if="scope.row['operation'] === 'check code'">
              <span>领取手机：</span>
              <span>{{
                scope.row["afterEditContent"].sendPhone
                  ? scope.row["afterEditContent"].sendPhone
                  : "无"
              }}</span>
            </div>
          </div>
          <div class="omitText" v-else-if="prop === 'gift_type'">
            <span v-if="scope.row['type'] !== null">{{
              scope.row["type"] | filterGiftType
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'tag'">
            <span>{{
              scope.row[prop] !== null ? scope.row[prop].name : "-"
            }}</span>
          </div>
          <!-- 多标签（数组） -->
          <div class="omitText" v-else-if="prop === 'tags'">
            <div v-if="Array.isArray(scope.row[prop]) && scope.row[prop].length" class="tags-cell">
              <div v-for="(t, tIndex) in scope.row[prop]" :key="t && t.id ? t.id : tIndex" class="tag-pill"
                :title="t && t.name ? t.name : t">
                {{ t && t.name ? t.name : t }}
              </div>
            </div>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'repeat'">
            <span v-if="scope.row[prop] !== null">{{
              scope.row[prop] | filterRepeat
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'isNeedPopup'">
            <span>{{ scope.row[prop] ? "是" : "否" }}</span>
          </div>
          <div class="omitText" v-else-if="prop === 'reply'">
            <span v-if="scope.row[prop] !== null">{{
              scope.row[prop] | filterReply
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'gift_source'">
            <span v-if="scope.row[prop] !== null">{{
              scope.row["source"] | filterSource
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'cbPageCount'">
            <span v-if="scope.row['pageNameList'] !== null">{{
              scope.row["pageNameList"].pageNameList.length
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'cBstatus'">
            <span v-if="scope.row['status'] !== null">{{
              scope.row["status"] === 1 ? "正常" : "回收站"
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'associationType'">
            <span v-if="scope.row['association'] !== null">{{
              scope.row["association"].associationType ? "阅读笔记" : "本地笔记"
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'notePointSize'">
            <span v-if="scope.row['notePointSize'] !== null">{{
              scope.row[prop] | renderSize
            }}</span>
            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'gift_platform'">
            <span v-if="scope.row['source'] === 'wechat'">微信</span>
            <span v-if="scope.row['source'] === 'jd'">京东</span>
            <span v-if="scope.row['source'] === 'weibo'">微博</span>
            <span v-if="scope.row['source'] === 'tianmao'">天猫</span>
            <span v-if="scope.row['source'] === 'youzan'">有赞</span>
            <span v-if="scope.row['source'] === 'suning'">苏宁</span>
            <span v-if="scope.row['source'] === 'zhihu'">知乎</span>
            <span v-if="scope.row['source'] === 'qqQun'">QQ群</span>
            <span v-if="scope.row['source'] === 'wexinQun'">微信群</span>
          </div>
          <div class="omitText" v-else-if="prop === 'role_name'">
            <span>{{ scope.row["role"] ? scope.row["role"].name : "-" }}</span>
          </div>
          <div class="omitText" v-else-if="prop === 'keywords'">
            <span>{{
              scope.row["keywords"].length
                ? scope.row["keywords"].join("\\")
                : "-"
            }}</span>
          </div>
          <div class="omitText" v-else-if="prop === 'devices' || prop === 'orgs'">
            <span>{{
              scope.row[prop] !== null ? scope.row[prop].length : "-"
            }}</span>
          </div>
          <div class="omitText" v-else-if="prop === 'user_devices'">
            <el-popover v-if="
              scope.row['devices'] !== null && scope.row['devices'].length
            " :width="500" trigger="click">
              <div class="userDeviceItem" v-for="item of scope.row['devices']" :key="item.id">
                <p class="userDeviceItem-model">{{ item.model }}</p>
                <p class="userDeviceItem-version">
                  {{ item.buildId }}
                </p>
                <p class="userDeviceItem-mac">{{ item.macAddress }}</p>
              </div>
              <span slot="reference" class="userDevicesCount">{{
                scope.row["devices"].length
              }}</span>
            </el-popover>

            <span v-else>-</span>
          </div>
          <div class="omitText" v-else-if="prop === 'apps'">
            <span v-for="(item, index) in scope.row[prop]" :key="item.id">
              {{ item.name }}
              <i v-if="index !== scope.row[prop].length - 1">、</i>
            </span>
          </div>
          <div v-else-if="prop === 'move'" class="appTable-move">
            <i class="move-up" v-if="scope.$index !== 0" @click="tableSort('up', scope)"></i>
            <i class="move-down" v-if="scope.$index !== tableData.length - 1" @click="tableSort('down', scope)"></i>
          </div>
          <div class="omitText" v-else-if="prop === 'timeRange'">
            <span>{{ scope.row["start"] | filterTime }}</span> -
            <span>{{ scope.row["end"] | filterTime }}</span>
          </div>
          <div class="omitText" v-else-if="prop === 'activityTime'">
            <span>{{ scope.row["startAt"] | filterTime }}</span> -
            <span>{{ scope.row["endAt"] | filterTime }}</span>
          </div>
          <div v-else-if="prop === 'handle'">
            <span v-for="item in btn" :key="item">
              <!-- <span v-if="item === 'swithBtn'">12312 </span> -->
              <el-switch v-if="item === 'swithBtn'" v-model="scope.row['status']" active-color="#13ce66"
                inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="switchChange(scope)">
              </el-switch>
              <span v-else-if="item === '状态' && scope.row.statusBtnText" :class="getStatusBtnClass(scope.row.status)"
                @click="tableHandle(item, scope)">{{ scope.row.statusBtnText }}</span>
              <span v-else-if="item === '推荐' && scope.row.status === 1" style="display: none;"></span>
              <span v-else :class="btnStyle(item)" @click="tableHandle(item, scope)">{{ item }}</span>
            </span>
          </div>
          <div v-else-if="prop === 'giftHandle'">
            <span class="checkDetailsBtn" @click="giftHandle('commonMsg.checkDetails', scope)">{{
              $t("commonMsg.checkDetails") }}</span>
            <span v-if="!scope.row['status']" class="checkDetailsBtn" @click="giftHandle('commonMsg.edit', scope)">{{
              $t("commonMsg.edit") }}</span>

            <span v-if="scope.row['cardGetCount'] > 0">{{
              $t("commonMsg.del")
            }}</span>
            <span v-if="
              (!scope.row['status'] &&
                userInfo.roleValue === 1 &&
                scope.row['cardGetCount'] === 0) ||
              (!scope.row['status'] &&
                userInfo.roleValue === 1 &&
                !scope.row['cardGetCount'])
            " class="delBtn" @click="giftHandle('commonMsg.del', scope)">{{ $t("commonMsg.del") }}</span>
          </div>

          <!-- 卡片管理操作 -->
          <div v-else-if="prop === 'cardHandle'">
            <span class="checkDetailsBtn" @click="giftHandle('commonMsg.checkDetails', scope)">{{
              $t("commonMsg.checkDetails") }}</span>
            <span v-if="!scope.row['status']" class="checkDetailsBtn" @click="giftHandle('commonMsg.edit', scope)">{{
              $t("commonMsg.edit") }}</span>

            <span v-if="scope.row['cardOutCount'] > 0">{{
              $t("commonMsg.del")
            }}</span>
            <span v-if="
              (!scope.row['status'] &&
                userInfo.roleValue === 1 &&
                scope.row['cardOutCount'] === 0) ||
              (!scope.row['status'] &&
                userInfo.roleValue === 1 &&
                !scope.row['cardOutCount'])
            " class="delBtn" @click="giftHandle('commonMsg.del', scope)">{{ $t("commonMsg.del") }}</span>
          </div>

          <!-- 诗词分类操作 -->
          <div v-else-if="prop === 'poetryHandle'">
            <span class="checkDetailsBtn" @click="giftHandle('commonMsg.checkDetails', scope)">{{
              $t("commonMsg.checkDetails") }}</span>
            <span v-if="!scope.row['status']" class="checkDetailsBtn" @click="giftHandle('commonMsg.edit', scope)">{{
              $t("commonMsg.edit") }}</span>

            <!-- 发布 -->
            <span v-if="!scope.row['publish']" class="checkDetailsBtn"
              @click="giftHandle('commonMsg.release', scope)">{{ $t("commonMsg.release") }}</span>

            <!-- 取消发布 -->
            <span v-if="scope.row['publish']" class="checkDetailsBtn"
              @click="giftHandle('commonMsg.cancelRelease', scope)">{{ $t("commonMsg.cancelRelease") }}</span>

            <span v-if="!scope.row['status'] && userInfo.roleValue === 1" class="delBtn"
              @click="giftHandle('commonMsg.del', scope)">{{ $t("commonMsg.del") }}</span>
          </div>

          <div v-else-if="prop === 'giftDetailsHandle'">
            <!-- 回收 开始 -->
            <span v-if="
              scope.row['actived'] !== undefined && scope.row['actived'] === 1
            " class="checkDetailsBtn" style="color: #888; cursor: default">{{ $t("commonMsg.recovery") }}</span>
            <span v-if="
              (scope.row['actived'] !== undefined &&
                scope.row['actived'] === 0) ||
              scope.row['actived'] === undefined
            ">
              <span v-if="scope.row['status'] !== 1" class="checkDetailsBtn"
                @click="giftHandle('commonMsg.recovery', scope)">{{ $t("commonMsg.recovery") }}</span>
            </span><!-- 回收 结束 -->

            <!-- 编辑 开始 -->
            <span v-if="
              scope.row['actived'] !== undefined && scope.row['actived'] === 1
            " class="checkDetailsBtn" style="color: #888; cursor: default">{{ $t("commonMsg.edit") }}</span>
            <span v-if="
              (scope.row['actived'] !== undefined &&
                scope.row['actived'] === 0) ||
              scope.row['actived'] === undefined
            ">
              <span v-if="!scope.row['status']" class="checkDetailsBtn" @click="giftHandle('commonMsg.edit', scope)">{{
                $t("commonMsg.edit") }}</span> </span><!-- 编辑 结束 -->

            <!-- 操作历史 开始 -->
            <span class="checkDetailsBtn" @click="giftHandle('sale.gift.handle', scope)">{{ $t("sale.gift.handle")
            }}</span><!-- 操作历史 结束 -->

            <!-- 删除 开始 -->
            <span v-if="
              scope.row['actived'] !== undefined && scope.row['actived'] === 1
            " class="checkDetailsBtn" style="color: #888; cursor: default">{{ $t("commonMsg.del") }}</span>
            <span v-if="
              (scope.row['actived'] !== undefined &&
                scope.row['actived'] === 0) ||
              scope.row['actived'] === undefined
            ">
              <span v-if="!scope.row['status'] && userInfo.roleValue === 1" class="delBtn"
                @click="giftHandle('commonMsg.del', scope)">{{ $t("commonMsg.del") }}</span> </span><!-- 删除 结束 -->
          </div>

          <div v-else-if="prop === 'cardDetailsHandle'">
            <span v-if="
              scope.row['actived'] !== undefined && scope.row['actived'] === 1
            " class="checkDetailsBtn" style="color: #888; cursor: default">{{ $t("commonMsg.edit") }}</span>
            <span v-if="
              (scope.row['actived'] !== undefined &&
                scope.row['actived'] === 0) ||
              scope.row['actived'] === undefined
            ">
              <span v-if="!scope.row['status']" class="checkDetailsBtn" @click="giftHandle('commonMsg.edit', scope)">{{
                $t("commonMsg.edit") }}</span>
            </span>

            <span class="checkDetailsBtn" @click="giftHandle('sale.gift.handle', scope)">{{ $t("sale.gift.handle")
            }}</span>

            <span v-if="
              scope.row['actived'] !== undefined && scope.row['actived'] === 1
            " class="checkDetailsBtn" style="color: #888; cursor: default">{{ $t("commonMsg.del") }}</span>
            <span v-if="
              (scope.row['actived'] !== undefined &&
                scope.row['actived'] === 0) ||
              scope.row['actived'] === undefined
            ">
              <span v-if="!scope.row['status'] && userInfo.roleValue === 1" class="delBtn"
                @click="giftHandle('commonMsg.del', scope)">{{ $t("commonMsg.del") }}</span>
            </span>
          </div>

          <!-- 诗词库的详情操作管理 -->
          <div v-else-if="prop === 'poetryDetailsHandle'">
            <span class="checkDetailsBtn" @click="giftHandle('commonMsg.edit', scope)">{{ $t("commonMsg.edit") }}</span>

            <span class="delBtn" @click="giftHandle('commonMsg.del', scope)">{{
              $t("commonMsg.del")
            }}</span>
          </div>

          <div class="omitText" v-else-if="prop === 'card_status'">
            <span v-if="scope.row['status'] === 0">正常</span>
            <span v-if="scope.row['status'] === 1">已删除</span>
          </div>

          <div class="omitText" v-else-if="prop === 'card_detail_status'">
            <span v-if="scope.row['status'] === 0">正常</span>
            <span v-if="scope.row['status'] === 1">已删除</span>
          </div>

          <div class="omitText" v-else-if="prop === 'storage_used'">
            <span>{{ scope.row[prop] | renderSize }}</span>
            <!-- <span v-if="0 < scope.row[prop] && scope.row[prop] < 1024"
              >{{ scope.row[prop] }}B</span
            >

            <span v-if="1024 < scope.row[prop] && scope.row[prop] < 1024 * 1024"
              >{{ (scope.row[prop] / 1024).toFixed(1) }}KB</span
            >
            <span v-if="1024 === scope.row[prop]">1KB</span>

            <span
              v-if="
                1024 * 1024 < scope.row[prop] &&
                  scope.row[prop] < 1024 * 1024 * 1024
              "
              >{{ (scope.row[prop] / (1024 * 1024)).toFixed(1) }}MB</span
            >
            <span v-if="1024 * 1024 === scope.row[prop]">1MB</span> -->
          </div>
          <div v-else-if="prop === 'avatar'" class="avatar-cell">
            <el-image v-if="scope.row[prop]" :src="scope.row[prop]" class="avatar-img" fit="cover"
              :preview-src-list="[scope.row[prop]]"
              style="width: 40px; height: 40px; border-radius: 50%; overflow: hidden;"></el-image>
            <span v-else class="omitText">-</span>
          </div>
          <div v-else-if="prop === 'thumbnail'" class="thumbnail-cell">
            <el-image v-if="scope.row[prop]" :src="scope.row[prop]" class="thumbnail-img" fit="fill"
              :preview-src-list="[scope.row[prop]]"
              style="width: 80px; height: 60px; border-radius: 4px; overflow: hidden;"></el-image>
            <span v-else class="omitText">-</span>
          </div>
          <span v-else class="omitText">{{
            scope.row[prop] && scope.row[prop] !== null ? scope.row[prop] : "-"
          }}</span>
        </template>
      </el-table-column>
    </el-table>
    <transition name="fade">
      <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResizeMixin from "@/mixins/resize";
import DelPopup from "@/components/delPopup";

export default {
  components: {
    DelPopup,
  },
  computed: {
    ...mapGetters(["hasData", "delPopup", "userInfo"]),
    labelNo() {
      return this.$t("commonMsg.No");
    },
  },
  mixins: [ResizeMixin],
  props: {
    refName: {
      type: String,
      default: "appTable",
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    tableWidth: {
      type: String,
      default: "width:100%",
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tableProps: {
      type: Array,
    },
    selectCtrl: {
      type: Boolean,
      default: false,
    },
    orderCtrl: {
      type: Boolean,
      default: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    expand: {
      type: Boolean,
      default: false,
    },
    pageSize: Number,
    tableSize: {
      type: String,
      default: "small"
    },
  },

  data() {
    return {
      selectDataIds: [],
      selectData: [],
      scopeItem: null,
    };
  },

  filters: {
    filterObj(obj, value) {
      let temp = value.split(".");
      if (temp.length === 2 && obj[temp[0]]) {
        return obj[temp[0]][temp[1]];
      } else if (temp.length === 3 && obj[temp[0]] && obj[temp[0]][temp[1]]) {
        return obj[temp[0]][temp[1]][temp[2]];
      }
    },
  },

  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;";
      }
    },

    btnStyle(item) {
      let className;
      switch (item) {
        case this.$t("commonMsg.checkDetails"):
        case this.$t("commonMsg.edit"):
        case "编辑":
        case "测试":
        case "复制链接":
        case "操作详情":
        case "推荐":
          className = "checkDetailsBtn";
          break;
        case this.$t("commonMsg.del"):
        case this.$t("commonMsg.remove"):
        case this.$t("commonMsg.destroy"):
        case this.$t("commonMsg.correction"):
        case this.$t("sale.gift.handle"):
        case "Token失效":
        case "数据清理邮件":
        case "笔记PDF修正":
        case "OSS查询":
        case "CB查询":
        case "书库查询":
        case "推送查询":
        case "禁用":
          className = "delBtn";

          break;

        default:
          break;
      }
      return className;
    },
    getStatusBtnClass(status) {
      // 状态按钮样式映射：0-成功(绿色), 1-危险(红色), 2-危险(红色), 3-信息(灰色)
      const statusColorMap = {
        0: "checkDetailsBtn success-btn", // 待上架 -> 上架 (绿色)
        1: "checkDetailsBtn danger-btn", // 已上架 -> 下架 (红色)
        2: "checkDetailsBtn danger-btn", // 已下架 -> 彻底下架 (红色)
        3: "checkDetailsBtn info-btn" // 已永久移除 -> 已彻底下架 (灰色)
      };
      return statusColorMap[status] || "checkDetailsBtn";
    },

    // 表格上下移动排序
    tableSort(type, scope) {
      this.emitEvn(type, scope, "tableSort");
    },

    switchChange(scope) {
      this.emitEvn(null, scope, "switchChange");
    },

    giftHandle(type, scope) {
      if (type === "commonMsg.del") {
        this.scopeItem = scope;
        this.$store.commit("windowHandle", "delPopup");
      } else {
        this.emitEvn(this.$t(type), scope, "tableHandle");
      }
    },

    showUserDevices(scope) {
      this.emitEvn("showUserDevices", scope, "tableHandle");
    },

    // 表格操作按钮
    tableHandle(type, scope) {
      if (type === this.$t("commonMsg.del")) {
        this.scopeItem = scope;
        this.$store.commit("windowHandle", "delPopup");
      } else {
        this.emitEvn(type, scope, "tableHandle");
      }
    },

    //  确认删除
    deleteHandle() {
      this.emitEvn(this.$t("commonMsg.del"), this.scopeItem, "tableHandle");
    },

    emitEvn(type, scope, evn) {
      let obj = {
        type: type || "",
        data: scope,
      };
      this.$emit(evn, obj);
    },

    selectOpt(selection, row) {
      if (this.selectDataIds.includes(row.id)) {
        let idx = this.selectDataIds.indexOf(row.id);
        this.selectDataIds.splice(idx, 1);
        this.selectData.splice(idx, 1);
      } else {
        this.selectDataIds = [...this.selectDataIds, row.id];
        this.selectData = [...this.selectData, row];
      }

      this.sendSelectData();
    },

    selectAll(selection) {
      if (!selection.length) {
        this.selectDataIds = [];
        this.selectData = [];
        return;
      }
      for (let item of selection) {
        if (!this.selectDataIds.includes(item.id)) {
          this.selectDataIds.push(item.id);
          this.selectData.push(item);
        }
      }

      this.sendSelectData();
    },

    sendSelectData() {
      this.$emit("tableSelection", {
        data: this.selectData,
        ids: this.selectDataIds,
      });
    },

    selectable(row, index) {
      return this.hasData.includes(row.id) ? false : true;
    },

    toggleSelection() {
      if (!this.selectDataIds.length) return;
      for (let row of this.tableData) {
        if (this.selectDataIds.includes(row.id))
          this.$refs[this.refName].toggleRowSelection(row, true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#table-wrap.table-wrapper {
  width: 100%;

  :deep(.el-table) {
    width: 100%;
  }

  :deep(.el-table__body-wrapper) {
    overflow-x: auto !important;
  }

  :deep(.el-table__header-wrapper) {
    overflow-x: hidden !important;
  }

  :deep(.el-table__fixed) {
    overflow-x: hidden !important;
  }

  :deep(.el-table__fixed-right) {
    overflow-x: hidden !important;
  }

  .appTable-move {
    >i {
      display: inline-block;
      width: 22px;
      height: 22px;
      cursor: pointer;
      font-size: 20px;
      margin: 0 5px;
      font-weight: bold;
      vertical-align: middle;
    }

    .move-up {
      background: url("~@/assets/img/cmb_move_up.png") no-repeat;
    }

    .move-down {
      background: url("~@/assets/img/cmb_move-down.png") no-repeat;
    }
  }

  .userDevicesCount {
    cursor: pointer;
    color: $globalBGColor;
    text-decoration: underline;
  }
}

.tags-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

.tag-pill {
  color: #67c23a;
  background: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  padding: 0 6px;
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
}

.userDeviceItem {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #ccc;

  .userDeviceItem-model {
    min-width: 120px;
    color: $globalBGColor;
    font-weight: 500;
    margin-right: 5px;
  }

  .userDeviceItem-version {
    flex: 1;
    margin: 0 10px;
  }

  .avatar-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    overflow: hidden;
    padding: 4px 0;
    line-height: 1;
    vertical-align: middle;

    :deep(.avatar-img) {
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
      min-height: 40px !important;
      max-width: 40px !important;
      max-height: 40px !important;
      border-radius: 50% !important;
      flex-shrink: 0;
      display: inline-block !important;
      vertical-align: middle;
    }

    :deep(.el-image__inner) {
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
      min-height: 40px !important;
      max-width: 40px !important;
      max-height: 40px !important;
      border-radius: 50% !important;
      object-fit: cover !important;
    }

    :deep(.el-image) {
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
      min-height: 40px !important;
      max-width: 40px !important;
      max-height: 40px !important;
      border-radius: 50% !important;
      flex-shrink: 0;
      display: inline-block !important;
      vertical-align: middle;
      overflow: hidden;
    }
  }

  .thumbnail-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    overflow: hidden;
    padding: 4px 0;
    line-height: 1;
    vertical-align: middle;

    :deep(.thumbnail-img) {
      width: 80px !important;
      height: 60px !important;
      min-width: 80px !important;
      min-height: 60px !important;
      max-width: 80px !important;
      max-height: 60px !important;
      border-radius: 4px !important;
      flex-shrink: 0;
      display: inline-block !important;
      vertical-align: middle;
    }

    :deep(.el-image__inner) {
      width: 80px !important;
      height: 60px !important;
      min-width: 80px !important;
      min-height: 60px !important;
      max-width: 80px !important;
      max-height: 60px !important;
      border-radius: 4px !important;
      object-fit: fill !important;
    }

    :deep(.el-image) {
      width: 80px !important;
      height: 60px !important;
      min-width: 80px !important;
      min-height: 60px !important;
      max-width: 80px !important;
      max-height: 60px !important;
      border-radius: 4px !important;
      flex-shrink: 0;
      display: inline-block !important;
      vertical-align: middle;
      overflow: hidden;
    }
  }

  .userDeviceItem-version {
    width: 80px;
  }

  .status-success {
    color: #67c23a !important;
  }

  .status-danger {
    color: #f56c6c !important;
  }

  .status-info {
    color: #909399 !important;
  }
}
</style>
